import React from 'react';
import styles from './FolderLink.module.scss';
import classNames from 'classnames';
import queryString from 'query-string';
import { Link, useRouteMatch, useParams } from 'react-router-dom';
import { getFolderLink } from 'screens/FolderScreen/utils';

interface FolderLinkProps {
  nodeId: string;
  name: string;
}

export const FolderLink: React.FC<FolderLinkProps> = ({ nodeId, name }) => {
  const { folderId } = useParams();
  const currentNode = folderId;
  const nextNode = nodeId;

  const isFolderRoute = useRouteMatch({
    path: '/folder',
  });

  if (isFolderRoute) {
    const params = queryString.parse(window.location.href.split(currentNode as string)[1], {
      arrayFormat: 'comma',
    });
    return (
      <Link
        to={getFolderLink(params, nextNode, currentNode)}
        className={classNames(styles.title, styles.clickable)}
      >
        {name}
      </Link>
    );
  } else {
    return (
      <Link to={'/folder/' + nextNode} className={classNames(styles.title, styles.clickable)}>
        {name}
      </Link>
    );
  }
};
